import { Subscription } from 'rxjs';
import { PLUGIN_ERROR } from '@tv2-player/unifiedplayer/src/core/events';
import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import cast from '../../types/chromecast-caf-receiver/index';
import { errorAction, playerFilter } from '../extensions';

export class ErrorListenerPlugin implements PluginInterface {
  private pluginSubscription: Subscription;

  init(context: CastReceiverContext) {
    context.getPlayerManager().addEventListener(cast.framework.events.EventType.ERROR, e => {
      errorAction.perform(e);
    });
    window.addEventListener('error', e => {
      errorAction.perform(e);
    });
    window.addEventListener('unhandledrejection', e => {
      errorAction.perform(e);
    });
    playerFilter.register(async player => {
      this.pluginSubscription?.unsubscribe();
      this.pluginSubscription = player.observe(PLUGIN_ERROR).subscribe(e => {
        errorAction.perform(e);
      });
      return player;
    });
  }
}
